import { colors, orientations, sizes } from "./constants";
import Loader from "./Loader";

export { Loader as default, colors, orientations, sizes };
